import React from "react";
import styled from "styled-components";
import Colors from "../../../constants/Colors";
import {deviceMax, deviceMin} from "../../../../styles/device";

type ScrollButtonProps = {
    children: React.ReactNode;
}
const ScrollButton = (props : ScrollButtonProps) => {
    const handleClickScroll = () => {
        const element = document.getElementById('view-position');
        element?.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }

    return (
        <ScrollButtonComp onClick={handleClickScroll}>
            {props.children}
        </ScrollButtonComp>
    )
}

const ScrollButtonComp = styled.button`
  background-color: ${Colors.white};
  color: ${Colors.blackColor};
  padding: 14px 32px;
  text-align: center;
  border-radius: 36px;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  //z-index: 2;
  transition: all 0.2s ease;
  text-decoration: none;
  margin: 20px auto;
  border: none;
  width: fit-content;
  display: block;
  text-transform: uppercase;
  font-family: 'Manrope', sans-serif;
  letter-spacing: 0;

  &:hover {
    background-color: ${Colors.blackColor};
    color: ${Colors.white};
  }

  @media ${deviceMin.tablet} {
    display: none;
  }
  
`;

export default ScrollButton;